module.exports = __webpack_public_path__ + "static/media/popup.918b061d.svg";